import { makeStyles } from "@material-ui/core"

export const ContactStyle = makeStyles((theme) => ({
   wrapper: {
        padding:"0 15px",
   },
    phoneInput: {
        backgroundColor: theme.palette.background.default,
        '& fieldset': {
            border: 'none'
        },
        borderRadius: '5px',
    },
}));